import { written } from "./written_data"
import { Data } from "./types"

export const data: Data = {
    written: written
}

